import { GetReleaseByIdQuery, GetReleaseBySlugQuery } from "~graphql/sdk";

export type Release =
  | GetReleaseByIdQuery["release"]
  | GetReleaseBySlugQuery["getReleaseBySlug"];

export enum QueryParams {
  SessionStart = "start",
  SessionContinue = "continue",
}
